///home/cockskiz/new.greatlysocial.com/frontend/src/pages/blog/BlogPost.js

import '../../custom.css'
import React from 'react'
import { Container } from 'react-bootstrap'
import { useParams, Link, Navigate } from 'react-router-dom'
import Seo, { SITE_URL, BRAND } from '../../components/Seo'

import { blogPosts } from '../../data/blogPosts'

export default function BlogPost () {
  const { slug } = useParams()
  const post = blogPosts.find(p => p.slug === slug)

  if (!post) return <Navigate to='/blog' replace />

  const url = `${SITE_URL}/blog/${post.slug}`
  const heroAbs = post.hero?.startsWith('http') ? post.hero : `${SITE_URL}${post.hero}`

  const articleLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: post.title,
    description: post.excerpt,
    image: heroAbs,
    datePublished: post.date,
    dateModified: post.updated || post.date,
    author: { '@type': post.author && post.author !== BRAND ? 'Person' : 'Organization', name: post.author || BRAND },
    publisher: {
      '@type': 'Organization',
      name: BRAND,
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/assets/logo/greatly-social-full.png` },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
  }

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Blog', item: `${SITE_URL}/blog` },
      { '@type': 'ListItem', position: 2, name: post.title, item: url },
    ],
  }

  return (
    <>
      <Seo
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        image={post.hero}
        type='article'
        publishedAt={post.date}
        modifiedAt={post.updated || post.date}
        author={post.author || BRAND}
        jsonLd={[articleLd, breadcrumbLd]}
      />
      <section className='full-bleed' style={{
        backgroundImage: `url(${post.hero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '320px'
      }} />

      <section className='py-5'>
        <Container style={{ maxWidth: 760 }}>
          <p className='text-muted small'>
            <Link to='/blog' className='me-2'>&larr; Back to Blog</Link>
            · {new Date(post.date).toLocaleDateString()} · {post.author}
          </p>
          <h1 className='fw-bold mb-4'>{post.title}</h1>

          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: post.html }} />

          <hr className='my-5' />
          <p className='small'>
            Enjoyed this? Try&nbsp;
            <Link to='/post-scheduling'>our scheduling features&nbsp;&rarr;</Link>
          </p>
        </Container>
      </section>
    </>
  )
}
